import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/deputies" exact component={List} />
		<Route path="/admin/deputies/create" component={Edit} />
		<Route path="/admin/deputies/:id" component={Edit} />
	</Switch>
);
